export const IMAGE_MIME_TYPES: (
  | 'image/png'
  | 'image/gif'
  | 'image/jpeg'
  | 'image/svg+xml'
  | 'image/webp'
)[] = ['image/png', 'image/gif', 'image/jpeg', 'image/svg+xml', 'image/webp']

export const PDF_MIME_TYPES: 'application/pdf'[] = ['application/pdf']
export const CSV_MIME_TYPES: 'text/csv'[] = ['text/csv']
export const VIDEO_MIME_TYPES: 'video/mp4'[] = ['video/mp4']
export const WORD_MIME_TYPES: (
  | 'application/msword'
  | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
)[] = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
]
export const EXCEL_MIME_TYPES: (
  | 'application/vnd.ms-excel'
  | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
)[] = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
]
export const POWERPOINT_MIME_TYPES: (
  | 'application/vnd.ms-powerpoint'
  | 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
)[] = [
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
]

export const ALL_VALID_EXTENSIONS = [
  // Images
  'png',
  'gif',
  'jpeg',
  'jpg',
  'svg',
  'webp',

  //videos
  'mp4',

  // pdf

  'pdf',
  // csv
  'csv',

  // docs
  'doc',
  'docx',

  // sheets
  'xls',
  'xlsx',

  // powerpoint
  'ppt',
  'pptx',
]

export const ONE_MB_FILE_SIZE = 1 * 1024 ** 2
export const TWO_MB_FILE_SIZE = 2 * 1024 ** 2
export const THREE_MB_FILE_SIZE = 3 * 1024 ** 2
export const FOUR_MB_FILE_SIZE = 4 * 1024 ** 2
export const FIVE_MB_FILE_SIZE = 5 * 1024 ** 2
